var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"role":"region","aria-label":"Message card"}},[_c('div',{staticClass:"text-xs-center successfull-msg center-content pa-3"},[_c('v-icon',{staticClass:"mb-3",attrs:{"color":"error"}},[_vm._v(" cancel ")]),_c('h1',{staticClass:"pb-4"},[_vm._v(_vm._s(_vm.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }